export const getLocation = () => {
  const { hostname, origin, search, reload } = window.location;
  return { hostname, origin, search, reload };
};
